import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { EInfoType } from 'src/app/core/enums/country-info-type.enum';

import { SsrHelperService } from 'src/app/core/services/ssr-helper.service';
import { CloudinaryService } from 'src/app/core/services/cloudinary.service';

import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';

import { AttractionInfoComponent } from 'src/app/shared/used-components/attraction-info/attraction-info.component';

export enum EAttractionTypes {
  INSIDE_CITY = 'in_dest',
  OUTSIDE_CITY = 'ex_dest',
}

@Component({
    selector: 'app-places-list',
    templateUrl: './places-list.component.html',
    styleUrls: ['./places-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxSkeletonLoaderModule, SafeHtmlPipe, TranslateModule, RouterLink]
})
export class PlacesListComponent implements OnInit, OnChanges {
  @Input() title = '';
  @Input() places: any[] = [];
  @Input() isFetching: boolean = false;
  @Input() isAttractions = false;

  public currentVisibleItems = 15;
  public fetchingItems: number[] = new Array(15);
  public readonly eAttractionTypes = EAttractionTypes;
  public readonly breakpointConfig = this.device;

  constructor(
    private cloudinaryService: CloudinaryService,
    private router: Router,
    private dialog: MatDialog,
    private device: DeviceDetectorService,
    private ssrHelperService: SsrHelperService,
  ) {}

  public get showMorePlacesCount(): number {
    return Math.max(this.places.length - this.currentVisibleItems, 0);
  }

  public get activePlaces(): any[] {
    return this.places.slice(0, this.currentVisibleItems);
  }

  ngOnInit(): void {
    this.updateItemsCount();
  }

  public ngOnChanges(): void {
    this.getCloudImg();
  }

  public showMore(): void {
    const screenWidth = window.innerWidth;
    this.currentVisibleItems += screenWidth > 1100 ? 15 : 12;
  }

  public async handleShowAttraction(ev: Event, place: any): Promise<void> {
    ev.stopPropagation();

    if (!this.isAttractions) {
      await this.router.navigate([place.link]);
      return;
    }

    this.dialog.open(AttractionInfoComponent, {
      width: '592px',
      maxWidth: '96vw',
      maxHeight: '96%',
      data: {
        title: place.name,
        imageUrl: place.imageUrl,
        description: place.shortDescription,
      },
    });
  }

  private updateItemsCount(): void {
    if (!this.ssrHelperService.userAgent) return;
    const screenWidth = window.innerWidth;
    this.currentVisibleItems = screenWidth > 1100 ? 15 : 12;
  }

  private getCloudImg(): void {
    for (let i = 0; i < this.places.length; i++) {
      const place = this.places[i];

      if (place && !place.imageUrl?.includes('cloudinary')) {
        this.places[i].imageUrl = this.cloudinaryService.getCloudImage(
          place.imageUrl,
        );
      }
    }
  }

  protected readonly eInfoType = EInfoType;
}
